import { SUGGESTIONS } from './actions'

export const isSearchSuggestionsLoadingSelector = state => !!state.loading.get(SUGGESTIONS.ACTION)

export const suggestionsSelector = ({ suggestion }) => suggestion.results.toJS()
